import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllParentlist = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [allParentlist, setAllParentlist] = useState([]);

  const getAllParentlist = ({ branchGuid, packGuid }) => {
    setLoading(true);
    axiosClient
      .get(
        `Product/Branch/Packaging/GetAllParentlist?GUID=${branchGuid}${
          packGuid ? `&PackGUID=${packGuid}` : ''
        }`,
      )
      .then(res => {
        if (res.status === 200) {
          //   enqueueSnackbar(res.data?.message, { variant: 'success' });
          setAllParentlist(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [getAllParentlist, loading, allParentlist];
};

export default useGetAllParentlist;
